<template>
  <div>
    <div class="border rounded-lg p-3 mb-3">
      <b-form-group class="mb-0">
        <b-form-checkbox v-model="perfil.status" value="1" unchecked-value="0">
          O perfil está ativo e visível?
        </b-form-checkbox>
      </b-form-group>
    </div>
    <h4>Identificação</h4>
    <div class="border rounded-lg p-3 mb-3">
      <b-row>
        <b-col cols="3">
          <b-form-group label="Tipo de Pessoa:">
            <select-tipo-pessoa v-model="tipoPessoa" />
          </b-form-group>
        </b-col>
        <template v-if="tipoPessoa === 'pessoa_juridica'">
          <b-col>
            <b-form-group label="Tipo de instituição:">
              <categorias-instituicoes
                v-model="perfil.categoria_instituicao_id"
                :state="validateState('categoria_instituicao_id')"
              />
              <b-form-invalid-feedback>
                Campo obrigatório!
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Subtipo da instituição:">
              <tipo-instituicoes
                v-model="perfil.tipo_instituicao_id"
                :category="perfil.categoria_instituicao_id"
                :state="validateState('tipo_instituicao_id')"
              />
              <b-form-invalid-feedback>
                Campo obrigatório!
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </template>
      </b-row>
      <b-row>
        <b-col cols="12">
          <hr class="border-bottom w-100 opacity-5 rounded my-3" />
        </b-col>
        <b-col cols="3">
          <b-form-group v-if="displayPersonalField" label="CPF:">
            <b-form-input
              v-model="perfil.documento"
              placeholder="CPF"
              :state="validateState('documento')"
            />
            <b-form-invalid-feedback v-if="!$v.perfil?.documento?.isValid">
              CPF inválido!
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-else label="CNPJ:">
            <b-form-input
              v-model="perfil.documento"
              placeholder="CPNJ"
              :state="validateState('documento')"
            />
            <b-form-invalid-feedback v-if="!$v.perfil?.documento?.isValid">
              CNPJ inválido!
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group v-if="displayPersonalField" label="Nome:">
            <b-form-input
              v-model="perfil.nome"
              placeholder="Nome"
              :state="validateState('nome')"
            />
            <b-form-invalid-feedback>
              Campo obrigatório!
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-else label="Razão social:">
            <b-form-input
              v-model="perfil.razao_social"
              placeholder="Razão social"
              :state="validateState('razao_social')"
            />
            <b-form-invalid-feedback>
              Nome é um campo obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!displayPersonalField">
        <b-col cols="3" />
        <b-col>
          <b-form-group label="Nome Fantasia:">
            <b-form-input
              v-model="perfil.nome_fantasia"
              placeholder="Nome Fantasia"
              :state="validateState('nome_fantasia')"
            />
            <b-form-invalid-feedback>
              Nome é um campo obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <h4 class="mt-3">Endereço</h4>
    <Endereco
      v-model="perfil.cidade"
      :cep.sync="perfil.cep"
      class="border rounded-lg p-3 mb-3"
    />

    <h4 class="mt-3">Preferências de Oportunidades</h4>
    <div class="border rounded-lg p-3 mb-3">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Áreas Temáticas:">
            <select-area v-model="perfil.areas" :multiple="true" />
            <b-form-invalid-feedback>
              Campo obrigatório!
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Categorias de Recursos:">
            <SelectCategorias
              v-model="perfil.categorias"
              class="list-categories"
            />
            <b-form-invalid-feedback>
              Campo obrigatório!
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import { mapState } from "vuex";
import debounce from "lodash/debounce";

import CategoriasInstituicoes from "./CategoriasInstituicoes.vue";
import TipoInstituicoes from "./TipoInstituicoes.vue";
import Endereco from "./Endereco.vue";
import SelectTipoPessoa from "./TipoPessoa.vue";
import SelectArea from "@/modules/areas/Components/SelectArea.vue";
import SelectCategorias from "@/modules/categorias/Components/SelectCategorias.vue";
import { maxLength } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  components: {
    CategoriasInstituicoes,
    Endereco,
    SelectArea,
    SelectCategorias,
    SelectTipoPessoa,
    TipoInstituicoes,
  },
  data: () => ({
    tipoPessoa: "",
  }),
  validations() {
    if (this.tipoPessoa === "pessoa_juridica") {
      return {
        perfil: {
          razao_social: {
            required,
          },
          nome_fantasia: {
            maxLength: maxLength(250),
          },
          documento: {
            isValid: helpers.withParams(
              { type: "isValid" },
              (value) => !value || cnpjValidator.isValid(value)
            ),
          },
          categoria_instituicao_id: {
            required,
          },
          tipo_instituicao_id: {
            required,
          },
        },
      };
    }

    return {
      perfil: {
        nome: {
          required,
        },
        documento: {
          isValid: helpers.withParams(
            { type: "isValid" },
            (value) => !value || cpfValidator.isValid(value)
          ),
        },
      },
    };
  },
  computed: {
    ...mapState("perfis", ["perfil"]),
    displayPersonalField() {
      return this.tipoPessoa === "pessoa_fisica";
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.perfil[name] || {};
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.perfil.$touch();
      return !this.$v.$invalid;
    },
    onlyNumbers(evt = window.event) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
      }

      return true;
    },
    validateProfileType() {
      const docNumber = this.perfil?.documento;
      const existsRazaoSocial = !!this.perfil?.razao_social;
      const isCNPJ = cnpjValidator.isValid(docNumber) || existsRazaoSocial;

      this.tipoPessoa = isCNPJ ? "pessoa_juridica" : "pessoa_fisica";
    },
  },
  watch: {
    tipoPessoa(value, oldValue) {
      if (!oldValue) return;

      if (value === "pessoa_fisica") {
        delete this.perfil.nome_fantasia;
        delete this.perfil.razao_social;
        delete this.perfil.tipo_instituicao_id;
        delete this.perfil.categoria_instituicao_id;

        this.perfil.documento = "";
      }

      if (value === "pessoa_juridica") {
        delete this.perfil.nome;
        this.perfil.documento = "";
      }
    },
    "perfil.documento": {
      handler(value) {
        if (this.tipoPessoa) return;

        this.validateProfileType();
      },
      immediate: false,
    },
    "perfil.cidade_id": {
      deep: true,
      handler: function (value) {
        if (!this.$refs["selecCidade"]) return;

        const cidade = this.$refs["selecCidade"].municipio;
        if (!cidade) return;

        this.$refs["selecEstado"].setBySigla(cidade.estado_sigla);
      },
    },
    "perfil.cidade": {
      deep: true,
      handler(value) {
        if (value?.id === this.perfil.cidade_id) return;

        this.perfil.cidade_id = value?.id;
      },
    },
  },
  created() {
    debounce(function () {
      this.validateProfileType();
    }, 500);
  },
};
</script>
<style scoped lang="scss">
.list-categories {
  max-width: 100%;
  width: 100%;
  display: inline-block;
  column-count: 3;
  column-gap: 32px;
  row-gap: 32px;
}

::v-deep
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background: #5e72e4;
}

::v-deep .custom-control-label {
  width: 100%;

  &:hover::before {
    transition: background 190ms;
    background: rgba(94, 114, 228, 0.1);
  }
}
</style>
